import { Component } from 'react';
import { Link } from 'react-router-dom';
import { get, isEmpty } from 'lodash-es';

import VisibilityWrapper from 'components/VisibilityWrapper';

import { getRelatedArticles } from 'constants/helpCenter';
import { ROOT } from '../../../../../../constants';

class RelatedLinks extends Component {
  state = {
    links: [],
    fetching: true,
  };

  componentDidMount() {
    getRelatedArticles(this.props.articleId)
      .then(({ data }) => {
        get(data, 'articles.items');
      })
      .then(links => this.setState({ links: links || [], fetching: false }));
  }

  render() {
    const { collectionId } = this.props;
    const { links } = this.state;

    return (
      <VisibilityWrapper isVisible={!isEmpty(links)}>
        <div className="section__related-block">
          <h3 className="title section__related-title">Related articles</h3>
          <ul className="section__related-list">
            {links.map((link, index) => (
              <li className="section__related-item" key={index}>
                {/* <Icon className="section__related-icon" icon="crazy" /> */}
                <Link
                  className="link section__related-link"
                  to={`${ROOT}/${collectionId}/${link.id}/${link.slug}`}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </VisibilityWrapper>
    );
  }
}

export default RelatedLinks;
